import { erpAxios } from '..';

const editDokument = async (data) => {
  const res = await erpAxios.post(`/dokumenti/edit`, data);
  return res;
};

export default editDokument;
